import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const HvacGlyph = /*#__PURE__*/createElement("g", {
  id: "hvac"
}, /*#__PURE__*/createElement("path", {
  d: "M43.28 40.84c-1.5-.29-2.6.17-3.93.58-.46.12-.93.29-1.39.35 0 .23-.06.46-.12.69.4.12.81.4 1.1.58.58.4 1.1.81 1.62 1.33.93.87 1.79 1.85 2.55 2.89.58.75 1.16 1.62 1.5 2.55 1.16 2.89-3.12 7.64-6.07 7.41-3.47-.35-1.91-5.03-1.16-7.87.23-1.62-.23-2.72-.58-4.17-.12-.52-.35-1.04-.35-1.56-.17.06-.41 0-.58-.06-.17.4-.4.81-.58 1.1-.35.64-.81 1.21-1.27 1.74-.81.98-1.74 1.85-2.72 2.66-.75.58-1.56 1.21-2.43 1.62-2.78 1.22-7.29-3.3-7.06-6.42.29-3.64 4.8-2.02 7.52-1.16 1.5.29 2.6-.23 3.93-.58.46-.12.98-.35 1.45-.41 0-.17 0-.4.06-.58-.41-.12-.87-.4-1.16-.58-.58-.4-1.1-.87-1.62-1.33-.93-.87-1.74-1.85-2.49-2.89-.58-.81-1.21-1.62-1.56-2.55-1.16-2.89 3.12-7.64 6.13-7.41 3.41.35 1.91 5.03 1.16 7.87-.29 1.62.17 2.72.52 4.17.12.46.29.98.35 1.45.23 0 .46 0 .64.06.12-.35.35-.69.52-.98.4-.64.81-1.21 1.27-1.74.81-.98 1.74-1.85 2.72-2.66.75-.64 1.56-1.22 2.43-1.62 2.78-1.22 7.35 3.3 7.06 6.31-.28 3.64-4.74 2.02-7.46 1.21z"
}), /*#__PURE__*/createElement("path", {
  d: "M66.52 22.87v17.1h-7.83c-1.61 0-2.93 1.27-3 2.87a19.076 19.076 0 01-19.09 18.3c-10.55 0-19.13-8.58-19.13-19.13s8.58-19.13 19.13-19.13h29.92m.88-3.01H36.61c-12.22 0-22.13 9.91-22.13 22.13 0 12.22 9.91 22.13 22.13 22.13 11.9 0 21.57-9.39 22.08-21.17h8.71c1.17 0 2.12-.95 2.12-2.12V21.99c0-1.17-.95-2.12-2.12-2.12z"
}));
const Hvac = createSvg({
  name: 'hvac',
  path: HvacGlyph
});

export default Hvac;
export { HvacGlyph };
